import { cx } from '@libs/classnames';
import { ArrowSlimIcon } from '@ui/icons/ArrowSlimIcon';

import styles from './SlimArrowButton.module.css';

export type Props = {
  className?: string;
  onClick?: () => void;
  size?: '36' | '32' | '28' | '24' | '20';
  direction: 'top' | 'right' | 'bottom' | 'left';
  colorPreset?: 'club' | 'golden' | 'currentColor' | 'gray';
  disabled?: boolean;
};
export function SlimArrowButton({
  className,
  onClick,
  direction,
  disabled,
  colorPreset = 'club',
  size = '36',
}: Props) {
  return (
    <span
      className={cx(
        className,
        styles.slimArrowButton,
        styles[direction],
        styles[('size_' + size) as 'size_36'],
        styles[('color_' + colorPreset) as 'color_club'],
        {
          [styles.disabled]: disabled,
        },
      )}
      onClick={onClick}
    >
      <ArrowSlimIcon />
    </span>
  );
}
